<template>
  <v-container class="pa-0">
    <v-btn
      outlined
      dense
      color="secondary"
      @click="compositeDialog = true"
      :height="isMobile || isTablet ? auto : pos ? 50 : 55"
      :width="isMobile || isTablet ? auto : pos ? 120 : 138"
    >
      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.66406 14.875H16.6641V2.875H4.66406V5.875" stroke="#030303" stroke-width="1.2" stroke-linejoin="round"/>
        <path d="M3.16406 14.875H12.1641V5.875H3.16406V8.875" stroke="#030303" stroke-width="1.2" stroke-linejoin="round"/>
        <path d="M7.66406 8.875H1.66406V14.875H7.66406V8.875Z" stroke="#030303" stroke-width="1.2" stroke-linejoin="round"/>
      </svg>
      <span class="mr-1" style="color: #000;">{{ propType == 'recieve' ? $t('compositeReceipt') : $t('compositePayment') }}</span>
    </v-btn>

    <!--compositeDialog-->
    <v-dialog
      v-model="compositeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="650"
    >
      <v-card
        class="pa-5"
      >
        <v-container class="pa-0 d-flex justify-space-between mb-5" :class="{'pa-5': isMobile}">
          <v-card-text class="text-h5 pa-0">{{ propType == 'recieve' ? $t('compositeReceipt') : $t('compositePayment') }}</v-card-text>
          <v-icon @click="compositeDialog = false">mdi-close</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-2" v-if="account != null && account.firstname != null && account.lastname != null" :class="{'pa-5': isMobile}">{{ $t('customer') }} : {{ account.firstname + ' ' + account.lastname }}</v-card-text>
        <v-card-text class="pa-0 text-caption secondary--text" v-else :class="{'pa-5': isMobile}">{{ $t('customer') }} : {{ $t('haveNot') }}</v-card-text>
        <v-container class="pa-0 d-flex align-center wrapper-total mt-2" :class="{'ma-5': isMobile}" :style="{ 'flex-direction': isMobile ? 'column' : '', 'width': isMobile ? '90%' : ''}">
          <v-container class="item d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-caption">{{ propType == 'recieve' ? $t('amountForRecieve') : $t('amountForPay') }}</v-card-text>
            <v-card-text class="pa-0 text-caption text-disable secondary--text">{{ $numberFormat(total) }}  {{ currency.symbol }}</v-card-text>
          </v-container>
          <v-container class="item d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-caption">{{ $t('total-discount') }}</v-card-text>
            <v-card-text class="pa-0 text-caption text-disable secondary--text">{{ $numberFormat(discount) }} {{ currency.symbol }}</v-card-text>
          </v-container>
          <v-container class="item d-flex justify-space-between align-center">
            <v-card-text class="pa-0 text-caption">{{ $t('total-tax') }}</v-card-text>
            <v-card-text class="pa-0 text-caption text-disable secondary--text">{{ $numberFormat(totalTax) }} {{ currency.symbol }}</v-card-text>
          </v-container>
        </v-container>
        <v-container class="pa-0 d-flex justify-space-between align-center my-3" :class="{'ma-5' : isMobile}" :style="{'width': isMobile ? '90%' : ''}">
          <v-card-text class="pa-0 text-body-2">{{ propType == 'recieve' ? $t('select the recieve option') : $t('select the payment option') }}</v-card-text>
          <v-container class="pa-0 d-flex align-center gap-1 ma-0" style="width: auto;">
            <v-btn
              color="secondary"
              outlined
              custom
              style="height: 32px !important;font-size: 8pt !important;"
              @click="openOptionsDialog('cash-format')"
            >
              {{ $t('cash-format') }}
              <v-icon size="16" class="mr-1">mdi-plus</v-icon>
            </v-btn>
            <v-btn
            v-if="pos"
            color="secondary"
            outlined
            custom
            disabled
            style="height: 32px !important;font-size: 8pt !important;"
            @click="openOptionsDialog('pos')"
            >
            {{ $t('pos') }}
            <v-icon size="16" class="mr-1">mdi-plus</v-icon>
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              custom
              style="height: 32px !important;font-size: 8pt !important;"
              @click="openOptionsDialog('check')"
            >
              {{ $t('check') }}
              <v-icon size="16" class="mr-1">mdi-plus</v-icon>
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              custom
              style="height: 32px !important;font-size: 8pt !important;"
              @click="openOptionsDialog('bank-deposit')"
            >
              {{ $t('bank-deposit') }}
              <v-icon size="16" class="mr-1">mdi-plus</v-icon>
            </v-btn>
          </v-container>
        </v-container>
        <v-data-table
          :headers="compositeTableHeaders"
          :items="compositeItems"
          :items-per-page="-1"
          hide-default-footer
          :height="(isMobile || isTablet ? 265 : 265)"
          fixed-header
          class="composite"
          :class="{'ma-5': isMobile}"
          :item-class="getRowClass"
        >
          <template v-slot:item.row="{ item, index }">
            <v-card-text
              v-if="item.row != null"
              class="pa-0 text-caption"
            >
              {{ item.row }}
            </v-card-text>
            <v-card-text
              v-if="item.row == null"
              class="pa-0 text-caption"
            >
              {{ index + 1 }}
            </v-card-text>
          </template>
          <template v-slot:item.type="{ item }">
            <v-card-text
              class="pa-0 text-caption"
            >
              {{ $t(item.compositeType) }}
            </v-card-text>
          </template>
          <template v-slot:item.date="{ item }">
            <v-card-text
              v-if="item.date != null && item.dueDate == null"
              class="pa-0 text-caption"
            >
              {{ item.date }}
            </v-card-text>
            <v-card-text
              v-if="item.date == null && item.dueDate != null"
              class="pa-0 text-caption"
            >
              {{ item.dueDate }}
            </v-card-text>
            <v-card-text
              v-if="item.date != null && item.dueDate != null"
              class="pa-0 text-caption"
            >
              {{ item.dueDate }}
            </v-card-text>
            <v-card-text
              v-if="item.date == null && item.dueDate == null"
              class="pa-0 text-caption text-disable secondary--text"
            >
              {{ $t('haveNot') }}
            </v-card-text>
          </template>
          <template v-slot:item.amount="{ item }">
            <v-card-text
              v-if="item.amount != null"
              class="pa-0 text-caption"
            >
              {{ Number(item.amount).toLocaleString('fa-IR') }} {{ currency.symbol }}
            </v-card-text>
            <v-card-text
              v-else
              class="pa-0 text-caption text-disable secondary--text"
            >
              {{ $t('haveNot') }}
            </v-card-text>
          </template>
          <template v-slot:item.other="{ item }">
            <v-card-text
              v-if="item.other != null"
              class="pa-0 text-caption"
            >
              <div v-if="item.other.bank != null" class="my-1">
                <span>{{ $t('bank') }} : </span>
                <span>{{ item.other.bank.name }}</span>
              </div>
              <div v-if="item.other.bank == null && item.other.bankName != null" class="my-1">
                <span>{{ $t('bank') }} : </span>
                <span>{{ item.other.bankName.name }}</span>
              </div>
              <div v-if="item.other.paymentByPos != null" class="my-1">
                <span>{{ $t('pos') }} : </span>
                <span>{{ item.other.paymentByPos }}</span>
              </div>
              <div v-if="item.other.fishermanNumber != null" class="my-1">
                <span>{{ $t('fishermanNumber') }} : </span>
                <span>{{ item.other.fishermanNumber }}</span>
              </div>
              <div v-if="item.other.number != null" class="my-1">
                <span>{{ $t('check-number') }} : </span>
                <span>{{ item.other.number }}</span>
              </div>
              <div v-if="item.other.transferOption != null" class="my-1">
                <span>{{ $t('transfer-type') }} : </span>
                <span>{{ $t(item.other.transferOption) }}</span>
              </div>
            </v-card-text>
            <v-card-text
              v-else-if="item.other == null"
              class="pa-0 text-caption"
            >
              <div v-if="item.bank != null && item.bankName == null" class="my-1">
                <span>{{ $t('bank') }} : </span>
                <span>{{ item.bank.name }}</span>
              </div>
              <div v-if="item.bank == null && item.bankName != null" class="my-1">
                <span>{{ $t('bank') }} : </span>
                <span>{{ item.bankName.name }}</span>
              </div>
              <div v-if="item.bank != null && item.bankName != null" class="my-1">
                <span>{{ $t('bank') }} : </span>
                <span>{{ item.bankName.name }}</span>
              </div>
              <div v-if="item.paymentByPos != null" class="my-1">
                <span>{{ $t('pos') }} : </span>
                <span>{{ item.paymentByPos }}</span>
              </div>
              <div v-if="item.fishermanNumber != null" class="my-1">
                <span>{{ $t('fishermanNumber') }} : </span>
                <span>{{ item.fishermanNumber }}</span>
              </div>
              <div v-if="item.number != null" class="my-1">
                <span>{{ $t('check-number') }} : </span>
                <span>{{ item.number }}</span>
              </div>
              <div v-if="item.transferOption != null" class="my-1">
                <span>{{ $t('transfer-type') }} : </span>
                <span>{{ $t(item.transferOption) }}</span>
              </div>
            </v-card-text>
            <v-card-text
              v-else
              class="pa-0 text-caption text-disable secondary--text"
            >
              {{ $t('haveNot') }}
            </v-card-text>
          </template>
          <template v-slot:header.edit="{ header }">
            <v-container class="pa-0 d-flex align-center ma-0 gap-3">
              {{ header.text }}
              <div
                @click="openDeleteDialog"
                style="cursor: pointer;"
              >
                <svg class="mt-1" width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z" fill="black"></path>
                </svg>
              </div>
            </v-container>
          </template>
          <template v-slot:item.edit="{ item, index }">
            <v-container class="pa-0 d-flex align-center ma-0 justify-space-between">
              <div
                @click="openOptionsDialog(item, 'edit')"
                style="cursor: pointer;"
                class="pr-2"
              >
                <svg width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.66797 14.5002H13.3346M3.77864 9.29156C3.49438 9.57645 3.33471 9.96244 3.33464 10.3649V12.5002H5.4833C5.88597 12.5002 6.27197 12.3402 6.55664 12.0549L12.89 5.71822C13.1741 5.43329 13.3337 5.0473 13.3337 4.64489C13.3337 4.24248 13.1741 3.85649 12.89 3.57156L12.2646 2.94489C12.1236 2.80379 11.9562 2.69187 11.7718 2.61554C11.5875 2.5392 11.39 2.49994 11.1905 2.5C10.991 2.50006 10.7935 2.53944 10.6092 2.6159C10.425 2.69235 10.2576 2.80437 10.1166 2.94556L3.77864 9.29156Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>
              <div
                @click="openDeleteDialog(item, index)"
                style="cursor: pointer;"
              >
                <svg width="15" height="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.625 3.375H5.5C5.56875 3.375 5.625 3.31875 5.625 3.25V3.375ZM5.625 3.375H10.375V3.25C10.375 3.31875 10.4312 3.375 10.5 3.375H10.375V4.5H11.5V3.25C11.5 2.69844 11.0516 2.25 10.5 2.25H5.5C4.94844 2.25 4.5 2.69844 4.5 3.25V4.5H5.625V3.375ZM13.5 4.5H2.5C2.22344 4.5 2 4.72344 2 5V5.5C2 5.56875 2.05625 5.625 2.125 5.625H3.06875L3.45469 13.7969C3.47969 14.3297 3.92031 14.75 4.45312 14.75H11.5469C12.0813 14.75 12.5203 14.3313 12.5453 13.7969L12.9312 5.625H13.875C13.9438 5.625 14 5.56875 14 5.5V5C14 4.72344 13.7766 4.5 13.5 4.5ZM11.4266 13.625H4.57344L4.19531 5.625H11.8047L11.4266 13.625Z" fill="black"></path>
                </svg>
              </div>
            </v-container>
          </template>
          <!--<template
            v-slot:body.append
          >
            <tr>
              <td colspan="6"></td>
            </tr>
            <tr>
              <td colspan="2" style="width: 120px;border-left: 1px solid silver;">
                  <v-card-text class="pa-0 text-caption my-2">{{ $t('total-payments') }}</v-card-text>
                  <v-card-text
                    class="pa-0 text-caption mb-2"
                    :class="{ 'error--text': invoiceRemain < 0 }"
                  >
                    {{ $t('invoice-remain') }}
                  </v-card-text>
              </td>
              <td colspan="2" style="width: 228px;border-left: 1px solid silver;">
                  <v-card-text class="pa-0 text-caption my-2 pl-9 d-flex justify-end">{{ totalAmount.toLocaleString('fa-IR') }} {{ userInfo?.init?.currency?.name }}</v-card-text>
                  <v-card-text
                    class="pa-0 text-caption mb-2 pl-9 d-flex justify-end"
                    :class="{ 'error--text': invoiceRemain < 0 }"
                  >
                    {{ $numberFormat(invoiceRemain) }} {{ userInfo?.init?.currency?.name }}
                  </v-card-text>
              </td>
              <td colspan="1"></td>
              <td colspan="1"></td>
            </tr>
          </template>-->
          <!--<template v-slot:footer.prepend>
            <v-col
            v-show="!isMobile"
            cols="1"
            class="pa-0"
            style="margin-top: -10px"
            >
            <v-text-field
                v-model.number="page"
                :label="$t('goToPage')"
                min="1"
                :max="pageCount"
                type="number"
                outlined
                height="32"
                hide-details
                hide-spin-buttons
                dense
                :suffix="'  /  ' + pageCount"
            />
            </v-col>
        </template>-->
        </v-data-table>
        <v-container class="pa-0 d-flex justify-space-between mt-3">
          <div class="d-flex align-center gap-1">
            <v-btn
              dense
              color="primary"
              height="32"
              @click="confirmTable"
            >
              {{ $t('confirm') }}
            </v-btn>
            <!--<v-btn
              dense
              outlined
              color="secondary"
              height="32"
              @click="cancelTable"
            >
            {{ $t('cancel') }}
            </v-btn>-->
          </div>
          <v-card class="pa-3 table-overview" width="250px">
            <div class="d-flex justify-space-between gap-8 mb-2">
              <v-card-text class="pa-0 text-caption">{{ propType == 'recieve' ? $t('total-recieve') : $t('total-payments') }}</v-card-text>
              <v-card-text class="pa-0 text-caption">{{ totalAmount.toLocaleString('fa-IR') }} {{ currency.symbol }}</v-card-text>
            </div>
            <div class="d-flex justify-space-between gap-8">
              <v-card-text class="pa-0 text-caption" :class="{ 'error--text': invoiceRemain < 0 }">{{ $t('invoice-remain') }}</v-card-text>
              <v-card-text class="pa-0 text-caption" :class="{ 'error--text': invoiceRemain < 0 }">{{ $numberFormat(invoiceRemain) }} {{ currency.symbol }}</v-card-text>
            </div>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>

    <!--cash + pos + check + bankDeposit (dialog)-->
    <v-dialog
      v-model="optionsDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="720"
    >
      <v-card
        class="pa-5"
      >
        <v-container class="pa-0 d-flex justify-space-between mb-5" :class="{'pa-5': isMobile}">
          <v-card-text
            class="text-h5 pa-0"
          >
            {{ resolveMultiPaymentTitle() }}
          </v-card-text>
          <v-icon @click="optionsDialog = false" size="25">mdi-close</v-icon>
        </v-container>
        <v-row style="gap: 4rem;" class="mb-8" :class="{'pa-5': isMobile}">
          <v-col cols="12" md="7">
            <v-form ref="form" v-model="valid">
              <v-card-text class="pa-0 text-body-2 mb-5">{{ propType == 'recieve' ? $t('recieveSetting') : $t('paymentSetting') }}</v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <money
                    v-model="newRecord.amount"
                    :label="$t('amount')"
                    :dense="true"
                    :outlined="true"
                    :rules="[feeValidate]"
                    :solo="false"
                    :clearable="true"
                    class="mb-3 dense"
                    value-when-is-empty=""
                    :options="options"
                    :disabled="isCustomerCheck"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <autocomplete
                    v-if="propType == 'pay' && propType != 'recieve' && optionsFormat == 'check'"
                    v-model="newRecord.check"
                    :rules="[v => !!v || $t('is-required')]"
                    :title="$t('check')"
                    type="payCheck"
                    :value="newRecord.check"
                    @input="selectCheck"
                    @clear="clearCheck"
                  />
                </v-col>
              </v-row>
              <v-row v-if="optionsFormat == 'pos'" class="mt-1">
                <v-col cols="12" md="12">
                  <v-card-text class="pa-0 text-body-2 mb-3 mt-1">{{ $t('select-pos') }}</v-card-text>
                  <v-container class="pa-0 pos-wrapper ma-0">
                    <v-btn
                      custom
                      :outlined="selectedPos != item.value"
                      :color="selectedPos == item.value ? 'primary' : 'secondary'"
                      v-for="(item, index) in posOptions"
                      :key="index"
                      @click="selectPos(item)"
                    >
                      {{ item.posDevice.name }}
                    </v-btn>
                  </v-container>
                </v-col>
              </v-row>
              <v-card-text v-if="optionsFormat == 'check'" class="pa-0 text-body-2 mt-5">{{ $t('check-information') }}</v-card-text>
              <v-card-text v-if="optionsFormat == 'bank-deposit'" class="pa-0 text-body-2 mt-5">{{ $t('transfer-type') }}</v-card-text>
              <v-container v-if="optionsFormat == 'bank-deposit'" class="pa-0 transfer-wrapper ma-0 mt-3">
                <div
                  v-for="(item, index) in transferOptions"
                  :key="index"
                  class="flex-fill pa-2 d-flex justify-center"
                  @click="selectTransformOption(item)"
                  :style="{
                        'background-color': selectedTransferOption == item.value ? '#0066ff' : '',
                        'border-color': selectedTransferOption == item.value ? '#0066ff' : 'silver',
                        'color': selectedTransferOption == item.value ? '#fff' : ''
                        }"
                >
                  <v-card-text
                    class="pa-0 text-caption"
                  >
                    {{ item.label }}
                  </v-card-text>
                </div>
              </v-container>
              <v-row
                v-if="optionsFormat == 'cash-format' || optionsFormat == 'check' || optionsFormat == 'bank-deposit'"
                class="mt-3"
              >
                <v-col cols="12" md="6">
                  <autocomplete
                    v-if="optionsFormat == 'cash-format' || optionsFormat == 'bank-deposit'"
                    :title="$t('bank-or-fund')"
                    append-icon="mdi-chevron-down"
                    clear-icon="mdi-close"
                    outlined
                    dense
                    clearable
                    v-model="newRecord.bank"
                    :rules="[v => !!v || $t('is-required')]"
                    item-text="name"
                    return-object
                    type="bankCash"
                    :value="newRecord.bank"
                    :currency-prop="currency.id"
                  />
                  <autocomplete
                    v-if="optionsFormat == 'check' && propType == 'pay'"
                    :title="$t('bank')"
                    append-icon="mdi-chevron-down"
                    clear-icon="mdi-close"
                    outlined
                    dense
                    clearable
                    v-model="newRecord.bankName"
                    item-text="name"
                    return-object
                    :disabled="isCustomerCheck"
                    type="getBankList"
                    :value="newRecord.bankName"
                    :currency-prop="currency.id"
                  />
                  <autocomplete
                    v-if="optionsFormat == 'check' && propType == 'recieve'"
                    :title="$t('bank')"
                    append-icon="mdi-chevron-down"
                    clear-icon="mdi-close"
                    outlined
                    dense
                    clearable
                    v-model="newRecord.bankName"
                    item-text="name"
                    return-object
                    type="getBankList"
                    :value="newRecord.bankName"
                  />
                  <!--                         <v-text-field
                                            v-if="optionsFormat == 'check' && propType == 'recieve'"
                                            v-model="newRecord.bankName"
                                            :label="$t('bank')"
                                            :rules="[v => !!v || $t('is-required')]"
                                            outlined
                                            dense
                                            clearable
                                            :class="{'mt-5': isMobile}"
                                          /> -->
                </v-col>
                <v-col cols="12" md="6">
                  <template v-if="optionsFormat == 'cash-format' || optionsFormat == 'bank-deposit'">
                    <v-text-field
                      id="cashPaymentDate"
                      v-model="newRecord.date"
                      :label="$t('date')"
                      append-icon="mdi-calendar"
                      :rules="[v => !!v || $t('is-required')]"
                      outlined
                      dense
                      clearable
                      :class="{'mt-5': isMobile}"
                    />
                    <date-picker
                      v-model="newRecord.date"
                      element="cashPaymentDate"
                      :locale="$store.state.date_locale"
                      :format="$store.state.date_format"
                      auto-submit
                      :min="$store.state.startDate"
                      :max="$store.state.endDate"
                      :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                      @close="setDate"
                    />
                  </template>
                  <template v-if="optionsFormat == 'check'">
                    <v-text-field
                      id="cashPaymentDate"
                      v-model="newRecord.dueDate"
                      :label="$t('date-of-receipt')"
                      append-icon="mdi-calendar"
                      :rules="[v => !!v || $t('is-required')]"
                      outlined
                      dense
                      clearable
                      :class="{'mt-5': isMobile}"
                      :disabled="isCustomerCheck"
                    />
                    <date-picker
                      v-model="newRecord.dueDate"
                      element="cashPaymentDate"
                      :locale="$store.state.date_locale"
                      :format="$store.state.date_format"
                      auto-submit
                      :min="$store.state.startDate"
                      :max="$store.state.endDate"
                      :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                      @close="setDate"
                      :disabled="isCustomerCheck"
                    />
                  </template>
                </v-col>
                <v-col cols="12" md="6" class="mt-3" v-if="optionsFormat == 'check'">
                  <v-text-field
                    v-model="newRecord.number"
                    :label="$t('check-number')"
                    outlined
                    dense
                    clearable
                    :rules="[v => !!v || $t('is-required')]"
                    :disabled="isCustomerCheck"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="mt-3" v-if="optionsFormat == 'check'">
                  <v-text-field
                    v-model="newRecord.fishermanNumber"
                    :label="$t('fishermanNumber')"
                    outlined
                    dense
                    clearable
                    :disabled="isCustomerCheck"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-col cols="12" md="4">
            <v-container class="pa-0 ma-0">
              <v-card-text class="pa-0 text-body-2 mb-4">{{ $t('invoice-information') }}</v-card-text>
              <v-container class="pa-0 d-flex align-center gap-1">
                <img src="@/assets/imagePlacholder.png" style="width: 25px;border-radius: 4px;border: 1px solid silver;" />
                <v-card-text class="pa-0 text-body-2" v-if="account != null && account.firstname != null && account.lastname != null">{{ $t('customer') }} : {{ account.firstname + ' ' + account.lastname }}</v-card-text>
                <v-card-text class="pa-0 text-caption secondary--text" v-else>{{ $t('customer') }} : {{ $t('haveNot') }}</v-card-text>
              </v-container>
              <v-container class="pa-2 mt-2 amounts-wrapper">
                <div class="d-flex justify-space-between">
                  <v-card-text class="pa-0 text-caption">{{ $t('total-tax') }}</v-card-text>
                  <v-card-text class="pa-0 text-caption">{{ $numberFormat(totalTax) }} {{ currency.symbol }}</v-card-text>
                </div>
                <div class="d-flex justify-space-between">
                  <v-card-text class="pa-0 text-caption">{{ $t('total-discount') }}</v-card-text>
                  <v-card-text class="pa-0 text-caption">{{ $numberFormat(discount) }} {{ currency.symbol }}</v-card-text>
                </div>
                <div class="d-flex justify-space-between">
                  <v-card-text class="pa-0 text-caption">{{ propType == 'recieve' ? $t('amountForRecieve') : $t('amountForPay') }}</v-card-text>
                  <v-card-text class="pa-0 text-caption">{{ $numberFormat(total) }} {{ currency.symbol }}</v-card-text>
                </div>
                <div class="d-flex justify-space-between">
                  <v-card-text class="pa-0 text-caption">{{ propType == 'recieve' ? $t('total-recieve') : $t('total-payments') }}</v-card-text>
                  <v-card-text class="pa-0 text-caption">{{ totalAmount.toLocaleString('fa-IR') }} {{ currency.symbol }}</v-card-text>
                </div>
                <div class="d-flex justify-space-between">
                  <v-card-text
                    class="pa-0 text-caption"
                    style="color: #0066ff;"
                    :class="{ 'error--text': invoiceRemain < 0 }"
                  >
                    {{ $t('remain') }}
                  </v-card-text>
                  <v-card-text
                    class="pa-0 text-caption"
                    style="color: #0066ff;"
                    :class="{ 'error--text': invoiceRemain < 0 }"
                  >
                    {{ $numberFormat(invoiceRemain) }} {{ currency.symbol }}
                  </v-card-text>
                </div>
              </v-container>
            </v-container>
          </v-col>
        </v-row>
        <v-container class="pa-0 d-flex align-center gap-1">
          <v-btn
            v-if="optionsFormat == 'pos' && optionsDialogType != 'edit'"
            dense
            color="primary"
            height="32"
          >
            {{ $t('visit-pos') }}
          </v-btn>
          <v-btn
            v-else
            dense
            color="primary"
            height="32"
            @click="checkValidation"
          >
            {{ optionsDialogType == 'edit' ? $t('edit') : $t('confirm')}}
          </v-btn>
          <v-btn
            dense
            outlined
            color="secondary"
            height="32"
            @click="optionsDialog = false"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <!--delete dialog-->
    <v-dialog
      v-model="deleteDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2" v-if="!isAllItemsDeleting">{{ $t('Are you sure you want to delete this item ?') }}</v-card-text>
        <v-card-text class="pa-0 text-body-2" v-if="isAllItemsDeleting">{{ $t('are you sure you want to delete all items?') }}</v-card-text>
        <div v-if="!isAllItemsDeleting">
          <v-container v-if="deletedItem.type" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('type') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ $t(deletedItem.type) }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.date != null && deletedItem.dueDate == null" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('date') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.date }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.date == null && deletedItem.dueDate != null" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('date') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.dueDate }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.date != null && deletedItem.dueDate != null" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('date') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.dueDate }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.amount" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('amount') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ Number(deletedItem.amount).toLocaleString('fa-IR') }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.bank" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('bank') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.bank }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.pos" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('pos') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.pos }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.fishermanNumber" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('fishermanNumber') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.fishermanNumber  }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.checkNumber" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('check-number') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ deletedItem.checkNumber  }}</v-card-text>
          </v-container>
          <v-container v-if="deletedItem.transferOption" class="pa-0 d-flex align-center gap-1 mt-2">
            <v-card-text class="pa-0 text-body-2">{{ $t('transfer-type') }} : </v-card-text>
            <v-card-text class="pa-0 text-caption">{{ $t(deletedItem.transferOption) }}</v-card-text>
          </v-container>
        </div>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn
            color="error"
            height="32"
            @click="deleteItem"
          >
            {{ $t('yes') }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="deleteDialog = false"
          >
            {{ $t('no') }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>

    <!--check remain dialog-->
    <v-dialog
      v-model="checkRemainDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="350"
    >
      <v-card class="pa-5">
        <v-card-text class="pa-0 text-body-2">{{ $t('Are you sure you want to pay more than remain ?') }}</v-card-text>
        <v-container class="pa-0 d-flex align-center gap-1 mt-7">
          <v-btn
            color="error"
            height="32"
            @click="confirmRemain"
          >
            {{ $t('yes') }}
          </v-btn>
          <v-btn
            outlined
            height="32"
            color="secondary"
            @click="checkRemainDialog = false"
          >
            {{ $t('no') }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import General from '@/Mixins/general.js'

export default {
  name: 'InvoiceIndex',
  props: {
    totalTax: [Number, String],
    discount: [Number, String],
    total: String,
    account: Object,
    optionDialogType: String,
    propType: String,
    propDate: String,
    isInvoiceCreated: Boolean,
    editCompositeTableData: Array,
    currency: Object,
    pos: Boolean,
    posItems: Array
  },
  data: () => ({
    compositeDialog: false,
    compositeTableHeaders: [],
    compositeItems: [],
    newRecord: {
      id: null,
      type: null,
      amount: null,
      bank: null,
      date: null,
      paymentByPos: null,
      fishermanNumber: null,
      number: null,
      dueDate: null,
      account: null,
      bankAccountNumber: null,
      cashBox: null,
      bankName: null,
      check: null,
      kind: null,
      given: null,
      content: null,
      branch: null,
      transferOption: null,
      compositeType: null,
      status: 'active'
    },
    valid: true,
    bankItems: [],
    optionsDialog: false,
    optionsFormat: null,
    optionsDialogType: null,
    items: [],
    posOptions: [],
    selectedPos: null,
    selectedTransferOption: null,
    editedIndex: null,
    deleteDialog: false,
    deletedIndex: null,
    deletedItem: {
      type: null,
      date: null,
      amount: null,
      bank: null,
      pos: null,
      fishermanNumber: null,
      checkNumber: null,
      transferOption: null
    },
    isAllItemsDeleting: false,
    options: {
      locale: 'en-US',
      prefix: '',
      suffix: '  ',
      precision: 0
    },
    userInfo: null,
    banksNameItems: [],
    checkRemainDialog: false,
    isCustomerCheck: false
  }),
  mixins: [General],
  computed: {
    transferOptions () {
      return [
        { label: this.$t('cardToCard'), value: 'cardToCard' },
        { label: this.$t('accountToAccount'), value: 'accountToAccount' },
        { label: this.$t('ibanTransfer'), value: 'ibanTransfer' },
        { label: this.$t('satnaTransfer'), value: 'satnaTransfer' },
        { label: this.$t('payaTransfer'), value: 'payaTransfer' },
        { label: this.$t('plTransfer'), value: 'plTransfer' }
      ]
    },
    // total payment
    totalAmount () {
      return this.compositeItems.reduce((sum, item) => {
        // Calculate only if the status is not "deactive"
        if (item.status !== 'deactive') {
          sum += Number(item.amount) || 0
        }
        return sum
      }, 0)
    },
    /*     totalAmount () {
        return this.compositeItems.reduce((sum, item) => {
          return sum + (Number(item.amount) || 0) // Ensure it's a number
        }, 0)
      }, */
    // remain
    invoiceRemain () {
      const totalValue = Number(this.total) || 0
      const totalAmountValue = Number(this.totalAmount) || 0
      return totalValue - totalAmountValue
    }
    /*     computedBanks () {
        if (this.isCustomerCheck) {
          return this.newRecord.bankName ? [this.newRecord.bankName] : []
        }
        return this.banksNameItems
      } */
  },
  /* activated: function () {
      this.beforeMount()
    }, */
  beforeMount () {
    this.compositeTableHeaders = [
      {
        text: this.$t('#'),
        align: 'start',
        sortable: false,
        value: 'row',
        width: 25
      },
      {
        text: this.$t('type'),
        align: 'start',
        sortable: false,
        value: 'type'
      },
      {
        text: this.$t('date'),
        align: 'start',
        sortable: false,
        value: 'date'
      },
      {
        text: this.$t('amount'),
        align: 'start',
        sortable: false,
        value: 'amount'
      },
      {
        text: this.$t('other'),
        align: 'start',
        sortable: false,
        value: 'other'
      },
      {
        text: this.$t('edit'),
        align: 'start',
        sortable: false,
        value: 'edit'
      }
    ]
  },
  methods: {
    selectPos (item) {
      this.selectedPos = item.value
      this.newRecord.paymentByPos = item.label
    },
    selectTransformOption (item) {
      this.selectedTransferOption = item.value
      this.newRecord.transferOption = item.value
    },
    checkValidation () {
      if (this.$refs.form.validate() && this.editedIndex == null) {
        if (this.newRecord.amount > this.invoiceRemain) {
          this.checkRemainDialog = true
        } else {
          this.addNewRecord()
        }
      }
      if (this.$refs.form.validate() && this.editedIndex != null) {
        if (this.newRecord.amount > this.invoiceRemain) {
          this.checkRemainDialog = true
        } else {
          this.editRecord()
        }
      }
    },
    addNewRecord () {
      this.newRecord.compositeType = this.optionsFormat
      // add to table
      this.compositeItems.push(this.newRecord)
      if (this.optionsFormat == 'cash-format' || this.optionsFormat === 'bank-deposit') {
        this.newRecord.dueDate = null
        this.newRecord.bankName = null
      }
      if (this.optionsFormat == 'check') {
        this.newRecord.date = null
        this.newRecord.bank = null
      }
      // push to an array
      this.items.push({
        ...this.newRecord,
        type: this.optionsFormat === 'check'
          ? this.propType + 'Check'
          : this.propType
      })
      // emit that array
      this.$emit('update', this.items)
      console.log(JSON.stringify(this.items))
      // reset keys
      this.newRecord = {
        id: null,
        type: this.optionsFormat === 'check'
          ? this.propType + 'Check'
          : this.propType,
        /* amount: null, */
        bank: null,
        date: null,
        paymentByPos: null,
        fishermanNumber: null,
        number: null,
        dueDate: null,
        account: null,
        bankAccountNumber: null,
        cashBox: null,
        bankName: null,
        check: null,
        kind: null,
        given: null,
        content: null,
        branch: null,
        transferOption: null,
        compositeType: null,
        status: 'active'
      }
      // reset form
      this.$refs.form.reset()
      this.selectedPos = null
      this.selectedTransferOption = null
      // close the dialog
      this.optionsDialog = false
      /*       console.log('table after add record : ' + JSON.stringify(this.compositeItems))
        console.log('items after add record : ' + JSON.stringify(this.items)) */
    },
    editRecord () {
      this.newRecord.compositeType = this.optionsFormat
      // edit table
      this.compositeItems.splice(this.editedIndex, 1, this.newRecord)
      if (this.optionsFormat == 'cash-format' || this.optionsFormat === 'bank-deposit') {
        this.newRecord.dueDate = null
        this.newRecord.bankName = null
      }
      if (this.optionsFormat == 'check') {
        this.newRecord.date = null
        this.newRecord.bank = null
      }
      if (this.$route.path.includes('edit')) {
        this.items.splice(this.editedIndex, 1, {
          id: this.items[this.editedIndex].id,
          status: this.items[this.editedIndex].status,
          account: this.items[this.editedIndex].account,
          amount: this.newRecord.amount,
          bank: this.newRecord.bank,
          bankAccountNumber: this.items[this.editedIndex].bankAccountNumber,
          bankName: this.newRecord.bankName,
          branch: this.items[this.editedIndex].branch,
          cashBox: this.items[this.editedIndex].cashBox,
          check: this.newRecord.check,
          compositeType: this.items[this.editedIndex].compositeType,
          content: this.items[this.editedIndex].content,
          date: this.newRecord.date,
          dueDate: this.newRecord.dueDate,
          fishermanNumber: this.newRecord.fishermanNumber,
          given: this.items[this.editedIndex].given,
          kind: this.items[this.editedIndex].kind,
          number: this.newRecord.number,
          paymentByPos: this.newRecord.paymentByPos,
          transferOption: this.newRecord.transferOption,
          type: this.items[this.editedIndex].type
        })
      } else {
        this.items.splice(this.editedIndex, 1, {
          ...this.newRecord,
          type: this.optionsFormat === 'check'
            ? this.propType + 'Check'
            : this.propType
        })
      }
      this.editedIndex = null
      this.$emit('update', this.items)
      this.optionsDialog = false
      /* console.log('table after edit record : ' + JSON.stringify(this.compositeItems))
        console.log('items after edit record : ' + JSON.stringify(this.items)) */
    },
    openOptionsDialog (value, type) {
      this.optionsDialog = true
      if (type == null) {
        this.optionsFormat = value
        this.newRecord.amount = this.invoiceRemain
        this.newRecord.compositeType = this.optionsFormat
        this.newRecord.date = this.propDate
        this.newRecord.dueDate = this.propDate
        if (this.optionsFormat == 'bank-deposit') {
          this.selectedTransferOption = this.transferOptions[0].value
          this.newRecord.transferOption = this.transferOptions[0].value
        }
        if (this.optionsFormat == 'pos') {
          this.selectedPos = this.posOptions[0].value
          this.newRecord.paymentByPos = this.posOptions[0].value
        }
      }
      if (type === 'edit') {
        this.optionsFormat = value.compositeType
        this.newRecord.compositeType = this.optionsFormat
        this.optionsDialogType = type
        const selectedRecord = value
        if (this.$route.path.includes('edit')) {
          this.editedIndex = this.items.findIndex(item => item.id === selectedRecord.id)
        } else {
          this.editedIndex = this.items.findIndex(item => (item.amount === selectedRecord.amount) && (item.date != null ? item.date === selectedRecord.date : item.dueDate === selectedRecord.dueDate))
        }
        this.newRecord = {
          id: selectedRecord.id,
          type: this.optionsFormat === 'check'
            ? this.propType + 'Check'
            : this.propType,
          amount: selectedRecord.amount,
          bank: selectedRecord.bank,
          date: selectedRecord.date,
          paymentByPos: selectedRecord.paymentByPos,
          fishermanNumber: selectedRecord.fishermanNumber,
          number: selectedRecord.number,
          dueDate: selectedRecord.dueDate,
          account: null,
          bankAccountNumber: null,
          cashBox: null,
          bankName: selectedRecord.bankName,
          check: selectedRecord.check,
          kind: null,
          given: null,
          content: null,
          branch: null,
          transferOption: selectedRecord.transferOption,
          compositeType: selectedRecord.compositeType,
          status: 'active'
        }
        this.selectedPos = selectedRecord.paymentByPos
        this.selectedTransferOption = selectedRecord.transferOption
      }
    },
    resolveMultiPaymentTitle () {
      if (this.optionsFormat == 'cash-format') {
        if (this.optionsDialogType == 'edit') {
          return this.propType == 'recieve' ? this.$t('edit-cash-recieve') : this.$t('edit-cash-payment')
        }
        return this.propType == 'recieve' ? this.$t('new-cash-recieve') : this.$t('new-cash-payment')
      }
      if (this.optionsFormat == 'pos') {
        if (this.optionsDialogType == 'edit') {
          return this.$t('edit-pos-payment')
        }
        return this.$t('new-pos-payment')
      }
      if (this.optionsFormat == 'check') {
        if (this.optionsDialogType == 'edit') {
          return this.$t('edit-check')
        }
        return this.$t('check')
      }
      if (this.optionsFormat == 'bank-deposit') {
        if (this.optionsDialogType == 'edit') {
          return this.$t('edit-bank-deposit')
        }
        return this.$t('new-bank-deposit')
      }
    },
    openDeleteDialog (item, index) {
      /* console.log('index delete item' + index) */
      this.deleteDialog = true
      if (item != null && index != null) {
        this.deletedIndex = index
        this.deletedItem.type = item.type
        this.deletedItem.date = item.date
        this.deletedItem.dueDate = item.dueDate
        this.deletedItem.amount = item.amount
        this.deletedItem.bank = item.bank ? item.bank.name : item.bankName ? item.bankName.name : (item.bankName && item.bank) ? item.bank.name : null
        this.deletedItem.pos = item.paymentByPos
        this.deletedItem.fishermanNumber = item.fishermanNumber
        this.deletedItem.checkNumber = item.number
        this.deletedItem.transferOption = item.transferOption
      } else {
        this.isAllItemsDeleting = true
      }
    },
    deleteItem () {
      if (!this.isAllItemsDeleting) {
        if (this.compositeItems[this.deletedIndex]) {
          this.compositeItems[this.deletedIndex].status = 'deactive'
        }
        /*         const activeItems = this.compositeItems.filter(item => item.status == 'active')
          this.compositeItems = [...activeItems] */
        // this.compositeItems.splice(this.deletedIndex, 1)
        this.compositeItems.forEach((item, index) => {
          item.row = index + 1 // Adjust row to be the index + 1
        })
        // this.items.splice(this.deletedIndex, 1)
        if (this.items[this.deletedIndex]) {
          this.items[this.deletedIndex].status = 'deactive'
        }
      } else {
        this.compositeItems.forEach(item => (item.status = 'deactive'))
        // this.items = []
        this.items.forEach(item => (item.status = 'deactive'))
      }

      this.deleteDialog = false

      this.$emit('update', this.items)

      /* console.log('table after delete record : ' + JSON.stringify(this.compositeItems))
        console.log('items after delete record : ' + JSON.stringify(this.items)) */
      // set it to localstorage
      // localStorage.setItem('compositeItems', JSON.stringify(this.compositeItems))
    },
    fetchBanks () {
      var app = this
      app.$axios.get(app.$endpoint + 'getdetail', {
        params: {
          select: 'bankCash'
        }
      })
        .then(r => {
          this.bankItems = r.data.data
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
    },
    fetchBanksName () {
      var app = this
      app.$axios.get(app.$endpoint + 'getdetail', {
        params: {
          select: 'getBankList'
        }
      })
        .then(r => {
          this.banksNameItems = r.data.data
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
    },
    confirmRemain () {
      this.checkRemainDialog = false
      if (this.editedIndex == null) {
        this.addNewRecord()
      }
      if (this.editedIndex != null) {
        this.editRecord()
      }
    },
    confirmTable () {
      this.compositeDialog = false
    },
    /*     cancelTable () {
        this.compositeDialog = false
        this.compositeItems = []
      }, */
    selectCheck (select) {
      if (select) {
        if (select.type == 'customer') {
          this.isCustomerCheck = true
        }
        this.newRecord.amount = select.amount ? select.amount : this.newRecord.amount
        this.newRecord.fishermanNumber = select.fisherman_number ? select.fisherman_number : this.newRecord.fishermanNumber
        this.newRecord.number = select.number ? select.number : this.newRecord.number
        this.newRecord.bankName = select.bank_name ? { name: select.bank_name } : this.newRecord.bankName
        this.newRecord.dueDate = select.due_date ? select.due_date : this.newRecord.dueDate
      }
    },
    clearCheck () {
      this.isCustomerCheck = false
      this.newRecord.amount = null
      this.newRecord.fishermanNumber = null
      this.newRecord.number = null
      this.newRecord.bankName = null
      this.newRecord.dueDate = null
      this.$refs.form.reset()
    },
    getRowClass (item) {
      return item.status === 'deactive' ? 'd-none' : ''
    }
  },
  mounted () {
    // const storedData = localStorage.getItem('compositeItems')
    /* if (storedData) {
        this.compositeItems = JSON.parse(storedData)
      } */
    this.userInfo = JSON.parse(localStorage.getItem('token'))
    this.fetchBanks()
    this.fetchBanksName()
    this.newRecord.type = this.optionsFormat === 'check'
      ? this.propType + 'Check'
      : this.propType
    this.newRecord.date = this.propDate
    this.newRecord.dueDate = this.propDate
    /* if (this.transferOptions.length > 0) {
        this.selectedTransferOption = this.transferOptions[0].value
        this.newRecord.transferOption = this.transferOptions[0].label
      } */
  },
  watch: {
    optionsDialog (val) {
      if (!val) {
        // reset keys
        this.newRecord = {
          id: null,
          type: null,
          /* amount: null, */
          bank: null,
          date: this.propDate,
          paymentByPos: null,
          fishermanNumber: null,
          number: null,
          dueDate: null,
          account: null,
          bankAccountNumber: null,
          cashBox: null,
          bankName: null,
          check: null,
          kind: null,
          given: null,
          content: null,
          branch: null,
          transferOption: null,
          compositeType: null,
          status: 'active'
        }
        // reset form
        this.$refs.form.reset()
        this.selectedPos = null
        this.selectedTransferOption = null
        // reset text
        this.optionsDialogType = null
        this.optionsFormat = null
        this.editedIndex = null
        this.isCustomerCheck = false
        this.$emit('closeOptionsDialog')
      }
    },
    deleteDialog (val) {
      if (!val) {
        this.deletedIndex = null
        this.isAllItemsDeleting = false
      }
    },
    /*     invoiceRemain (val) {
        this.newRecord.amount = val
        this.$emit('invoiceRemain', val)
      }, */
    invoiceRemain: {
      immediate: true, // Emit immediately when component is created
      handler (val) {
        this.newRecord.amount = val
        this.$emit('invoiceRemain', val)
      }
    },
    optionDialogType (val) {
      if (val === 'cash-format') {
        this.openOptionsDialog('cash-format')
      }
    },
    totalAmount (val) {
      this.$emit('totalAmount', val)
    },
    isInvoiceCreated (val) {
      if (val) {
        this.compositeItems = []
      }
    },
    posItems (val) {
      if (val) {
        this.posOptions = val
        console.log(JSON.stringify(this.posOptions))
      }
    },
    editCompositeTableData: {
      handler (newValue) {
        if (newValue && newValue.length > 0) {
          /*           const activeItems = newValue.filter(item => item.status == 'active')
            this.compositeItems = [...activeItems] */
          this.compositeItems = [...newValue]
          this.items = [...newValue]
        } else {
          this.compositeItems = []
          this.items = []
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>
.v-application .overflow-y-auto {
  overflow-y: unset !important;
}
.wrapper-total {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-total .item {
  border-left: 1px solid silver;
  padding: 5px !important;
}
.v-card__text  {
  width: auto;
}
::v-deep .v-data-table.composite .v-data-table-header {
  background-color: #D9D9D9;
}
::v-deep .v-data-table.composite {
  border: 1px solid silver;
  /*  border-bottom: 0;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0; */
  /* height: 300px;
  overflow-y: auto; */
}
::v-deep .v-data-table.composite .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.composite .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.composite .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
/* ::v-deep .v-data-table.composite > .v-data-table__wrapper > table {
  height: 100%;
} */
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver;
  padding: 0 9px;
  color: black;
  height: 40px !important;
  /* background-color: #eeeeee; */
}
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > thead > tr > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > thead > tr > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 10px;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > tbody > tr > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
::v-deep .v-input__icon.v-input__icon--append .v-icon {
  font-size: 15px;
}
.amounts-wrapper {
  border-radius: 4px;
  border: 1px solid silver;
  display: flex;
  flex-direction: column;
  row-gap: .3rem;
}
.pos-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: .3rem;
}
.transfer-wrapper {
  border: 1px solid silver;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.transfer-wrapper > div {
  border-left: 1px solid silver;
  cursor: pointer;
}
.transfer-wrapper > div:last-child {
  border-left: 0 !important;
}
.table-overview {
  box-shadow: none !important;
  background-color: #f6f6f6;
}
.v-card__text {
  width: auto;
}
</style>
